import React from 'react';

const Home = () => {
    return (
        <div className='container-large'>
            <main>
                <div className='jumbo'>Andreu Salles</div>
                <div className='content-wrapper'>
                    <div>
                        Hi, I am a <span>Frontend Developer</span> and <span>Product Designer</span>. I design and build
                        delightful products in <span>React</span> and <span>Typescript</span>. My portfolio is currently
                        under construction. In the meanwhile, get in touch and check{' '}
                        <a href='https://restyoureyes.app' target='_blank' rel='noreferrer'>
                            Rest Your Eyes
                        </a>
                        , an iOS App developed in <span>Swift</span> and <span>SwiftUI</span>.
                    </div>
                    <div className='buttons-wrapper'>
                        <a href='https://www.linkedin.com/in/andreusalles/' target='_blank' rel='noreferrer'>
                            <button className='cta'>Get in touch!</button>
                        </a>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Home;
